import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.file.actions');
import { ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-project-file-actions',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/component.project.file.actions/view.scss */
/* src/app/component.project.file.actions/view.scss: no such file or directory */`],
})
export class ComponentProjectFileActionsComponent implements OnInit {
    @Input() canCreateFolder: boolean = false;
    @Input() canDownloadCurrent: boolean = false;
    @Input() canOpenWindow: boolean = false;
    @Input() canUpload: boolean = false;
    @Input() loading: boolean = false;
    @Input() actionBusy: boolean = false;
    @Input() uploadBusy: boolean = false;
    @Input() uploadAccept: string = '';

    @Output() createFolder = new EventEmitter<void>();
    @Output() downloadCurrent = new EventEmitter<any>();
    @Output() openWindow = new EventEmitter<any>();
    @Output() fileUpload = new EventEmitter<any>();
    @Output() folderUpload = new EventEmitter<any>();
    @Output() refresh = new EventEmitter<void>();

    @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;
    @ViewChild('folderInput') folderInput?: ElementRef<HTMLInputElement>;

    public actionMenuOpen: boolean = false;
    public uploadMenuOpen: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public async closeByDocumentClick() {
        if (!this.actionMenuOpen && !this.uploadMenuOpen) return;
        this.actionMenuOpen = false;
        this.uploadMenuOpen = false;
        await this.service.render();
    }

    public createDisabled() {
        return !!(this.loading || this.actionBusy);
    }

    public downloadDisabled() {
        return !!(this.loading || this.actionBusy || this.uploadBusy);
    }

    public openWindowDisabled() {
        return !!(!this.canOpenWindow || this.actionBusy || this.uploadBusy);
    }

    public uploadDisabled() {
        return !!(!this.canUpload || this.loading || this.actionBusy || this.uploadBusy);
    }

    public refreshDisabled() {
        return !!(this.loading || this.actionBusy || this.uploadBusy);
    }

    public uploadButtonLabel() {
        return this.uploadBusy ? '업로드 중' : '업로드';
    }

    public refreshIconClass() {
        return this.loading ? 'fa-solid fa-rotate-right animate-spin text-[12px]' : 'fa-solid fa-rotate-right text-[12px]';
    }

    public async toggleActionMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.actionMenuOpen = !this.actionMenuOpen;
        this.uploadMenuOpen = false;
        await this.service.render();
    }

    public async toggleUploadMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.uploadDisabled()) return;
        this.uploadMenuOpen = !this.uploadMenuOpen;
        this.actionMenuOpen = false;
        await this.service.render();
    }

    public emitCreateFolder(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.createDisabled()) return;
        this.actionMenuOpen = false;
        this.createFolder.emit();
    }

    public emitDownloadCurrent(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.downloadDisabled()) return;
        this.actionMenuOpen = false;
        this.downloadCurrent.emit(event || undefined);
    }

    public emitOpenWindow(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.openWindowDisabled()) return;
        this.actionMenuOpen = false;
        this.openWindow.emit(event || undefined);
    }

    public emitRefresh(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.refreshDisabled()) return;
        this.actionMenuOpen = false;
        this.refresh.emit();
    }

    public async pickFileUpload(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.uploadDisabled()) return;
        this.actionMenuOpen = false;
        this.uploadMenuOpen = false;
        if (this.fileInput && this.fileInput.nativeElement) this.fileInput.nativeElement.click();
        await this.service.render();
    }

    public async pickFolderUpload(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.uploadDisabled()) return;
        this.actionMenuOpen = false;
        this.uploadMenuOpen = false;
        if (this.folderInput && this.folderInput.nativeElement) this.folderInput.nativeElement.click();
        await this.service.render();
    }

    public async emitFileUpload(event: Event) {
        this.actionMenuOpen = false;
        this.uploadMenuOpen = false;
        this.fileUpload.emit(event);
        await this.service.render();
    }

    public async emitFolderUpload(event: Event) {
        this.actionMenuOpen = false;
        this.uploadMenuOpen = false;
        this.folderUpload.emit(event);
        await this.service.render();
    }
}

export default ComponentProjectFileActionsComponent;